import React from "react";
import { FullWidthSummaryDisplay } from "./FullWidthSummaryDisplay";
import { tileLayouts } from "./index";
import { OneThirdTwoThirdSummaryDisplay } from "./OneThirdTwoThirdSummaryDisplay";
import { OneThirdSummaryDisplay } from "./OneThirdSummaryDisplay";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SummaryTileProps } from "../../elements/SummaryTile/SummaryTile";
import { Collage } from "./Collage";

interface Props extends ComponentProps, ComponentWidth {
  tileLayout: tileLayouts;
  summaries: SummaryTileProps[];
  showEquals?: boolean;
  displayImages?: boolean;
  summaryAlignment?: "by_title" | "by_link";
  id: string;
}

const SummaryDisplay: React.FC<Props> = ({
  tileLayout,
  summaries,
  ...props
}) => {
  if (!summaries) return null;

  switch (tileLayout) {
    case "full_width":
      return <FullWidthSummaryDisplay summaries={summaries} {...props} />;
    case "thirds":
    case "quarters":
      return (
        <OneThirdSummaryDisplay
          summaries={summaries}
          tileLayout={tileLayout}
          {...props}
        />
      );
    case "collage":
      return <Collage summaries={summaries} {...props} />;
    default:
      return (
        <OneThirdTwoThirdSummaryDisplay
          summaries={summaries}
          tileLayout={tileLayout}
          {...props}
        />
      );
  }
};

export default SummaryDisplay;
